import { render, staticRenderFns } from "./CrmReports.vue?vue&type=template&id=b503e486&scoped=true"
import script from "./CrmReports.vue?vue&type=script&lang=js"
export * from "./CrmReports.vue?vue&type=script&lang=js"
import style0 from "./CrmReports.vue?vue&type=style&index=0&id=b503e486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b503e486",
  null
  
)

export default component.exports